/**
 * Generic `target` / `action` strings for event naming / tracking (e.g. `getEventName`).
 */
export const ANALYTICS_TARGET_LOCATION = "location";
export const ANALYTICS_TARGET_MESSAGE = "message";
export const ANALYTICS_TARGET_EMOJI = "emoji";
export const ANALYTICS_TARGET_STICKER = "sticker";
export const ANALYTICS_TARGET_PRODUCT = "product";
export const ANALYTICS_TARGET_BRAND = "brand";

export const ANALYTICS_EVENT_ACTION_CLICKED = "clicked";
export const ANALYTICS_EVENT_ACTION_CHANGED = "changed";
export const ANALYTICS_EVENT_ACTION_VIEWED = "viewed";
export const ANALYTICS_EVENT_ACTION_EXPANDED = "expanded";
export const ANALYTICS_EVENT_ACTION_COLLAPSED = "collapsed";
export const ANALYTICS_EVENT_ACTION_ADDED = "added";
export const ANALYTICS_EVENT_ACTION_SAVED = "saved";
export const ANALYTICS_EVENT_ACTION_EDITED = "edited";
export const ANALYTICS_EVENT_ACTION_SELECTED = "selected";
export const ANALYTICS_EVENT_ACTION_DESELECTED = "deselected";
export const ANALYTICS_EVENT_ACTION_REMOVED = "removed";
export const ANALYTICS_EVENT_ACTION_SUBMITTED = "submitted";
export const ANALYTICS_EVENT_ACTION_OPENED = "opened";
export const ANALYTICS_EVENT_ACTION_SWITCHED = "switched";
export const ANALYTICS_EVENT_ACTION_PERFORMED = "performed";
export const ANALYTICS_EVENT_ACTION_APPLIED = "applied";
export const ANALYTICS_EVENT_ACTION_UPDATED = "updated";
export const ANALYTICS_EVENT_ACTION_CLEARED = "cleared";
export const DEFAULT_EVENT_LOCATION_ANALYTICS = { track: true };
export const ANALYTICS_EVENT_ACTION_SCROLLED = "scrolled";
export const ANALYTICS_EVENT_ACTION_NAVIGATED = "navigated";
export const ANALYTICS_EVENT_ACTION_DOWNLOADED = "downloaded";
